import React from 'react';

import { FormattedMessage } from 'react-intl';
import useClipboard from 'react-use-clipboard';

import CopyIcon from '@atlaskit/icon/glyph/copy';
import { B400 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

import { Commit } from 'src/components/types';

import messages from './commit-page.i18n';
import * as styles from './commit-page.styled';

type CopyHashIconProps = { commit: Commit; isHovered: boolean };

/* eslint @typescript-eslint/ban-types: "warn" */
export const CopyHashIcon: React.FC<CopyHashIconProps> = ({
  commit,
  isHovered,
}) => {
  const [isCopied, setCopied] = useClipboard(commit.hash, {
    successDuration: 10000,
  });

  const tooltipContent = isCopied ? messages.hashCopied : messages.copyHash;

  const iconColor = isCopied
    ? token('color.icon.information', B400)
    : token('color.icon', 'black');

  const onHashClick = () => {
    setCopied();
  };
  const onHashEnter = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') setCopied();
  };

  return (
    <styles.CopyHashDrawer isHovered={isHovered}>
      <Tooltip
        position="right"
        content={<FormattedMessage {...tooltipContent} />}
      >
        <styles.CopyHashIcon
          tabIndex={0}
          onKeyPress={onHashEnter}
          onClick={onHashClick}
        >
          <CopyIcon
            primaryColor={iconColor}
            size="medium"
            label="copy commit hash"
          />
        </styles.CopyHashIcon>
      </Tooltip>
    </styles.CopyHashDrawer>
  );
};
